exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n.bootstrap-agendor .iconButton {\n  -webkit-border-radius: 100%;\n  -moz-border-radius: 100%;\n  -ms-border-radius: 100%;\n  border-radius: 100%;\n  background-color: rgba(232, 234, 238, 0.62);\n  color: #999;\n  cursor: pointer;\n  padding: 2px;\n  position: absolute;\n}\n\n.bootstrap-agendor .iconButton:hover {\n  color: #828282;\n  background: #D6D6D6;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/icon-button.scss
// module id = 578
// module chunks = 0